<template>
<div id="container" class="game">
    <div class="fullscreen_background">
        <img src="/static/assets/game/Hintergrund_2860.png" />
    </div>
    <top-menu />
    <top-logo />
    <stoppuhr />
    <lautsprecher />
    <copyright />
    <hintergrundbutton />
    <div class="z20 ursula">
    <img class="img" src="/static/assets/game/Ursula_Ungeheuer_bitte_verstecken_lassen.png" />
    </div>
    <div class="z20 pappschnee">
    <img class="img" src="/static/assets/game/Pappschnee-Team.png" />
    </div>
<div class="z30 pappschnee_hud">
    <img class="img" src="/static/assets/game/PappschneeHUD.png" />
    </div>
    <div class="coach z30">
        <img class="img" src="/static/assets/game/Coach_Karotte.png" />
    </div>
  <div class="wolke z30">
        <img class="img hovering2" src="/static/assets/game/wolke.png" />
    </div>
    <div class="stinkbombe z30">
        <img class="img" src="/static/assets/game/stinkbombe.png" />
    </div>
  <div class="angstfaenger z30">
        <img class="img" src="/static/assets/game/Libero_Angstfaenger.png" />
    </div>
    <div class="furchtlos z30">
        <img class="img" src="/static/assets/game/Gigi_Furchtlos.png" />
    </div>
	<div class="monsterschreck z30">
        <img class="img" src="/static/assets/game/Dubix_Monsterschreck.png" />
    </div>
    <div class="heldenhaft z30">
        <img class="img" src="/static/assets/game/Hugi_Heldenhaft.png" />
    </div>
    <div class="hud z30">  
      <img class="img" src="/static/assets/game/HUD-01.png" />
    </div>
    <router-link to="/wal" tag="div" class="pfeil_links_big z50 pointer">
        <img class="img" src="/static/assets/alle/Pfeil.png" />
    </router-link>

    <router-link to="/olympia" tag="div" class="pfeil_rechts_big z50 pointer">
        <img class="img" src="/static/assets/alle/Pfeil-1.png" />
    </router-link>

    <div class="geschichte z50">
        <img src="/static/assets/game/Textfeld.png" usemap="#geschichte-map">
        <player audiourl="https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies2022_Geschichte_3_Hugi_Heldenhaft.mp3" jsonurl="/static/assets/geschichten/Hugi_Heldenhaft.json" content=".game" target="game_target"/>
        <!-- // eslint-disable-next-line -->
      <vuescrollbar tag="div" class="fliesstext" id="game_target">
<p>Draußen regnete es in Strömen und die Hugidubies machten sich einen gemütlichen Lesenachmittag. Da klingelte es und ein großer Umschlag lag vor der Tür. „Für die Hugidubies“, las Gigi. „Ohne Absender!“, staunte Dubix und öffnete den Umschlag. „Ein altes Videospiel!“, stellte er fest, „Jagd auf die Wintermonster — das klingt spannend.“ Schnell lief er zur Spielkonsole und legte die CD ein. „Cool!“, rief Hugi, als auf dem Monitor eine felsige, zerklüftete Winterlandschaft erschien, über die ein eisiger Sturm pfiff. „Wähle deine Monsterjägerausrüstung und deinen Namen!“ lautete die erste Spielanweisung. „Ich fang an!“, erklärte Dubix, nannte sich „Dubix Monsterschreck“, entschied sich für einen weißen Schneeanzug, eine Schneebrille und Stinkbomben. Dann kam Libero an die Reihe: Die Hugidubies verpassten ihm ein Stirnband, ein dickes Wollmäntelchen und ein Monsterkazoo. „Damit kannst du den Monstern schöne Lieder blasen und sie zähmen, nicht wahr?“, meinte Gigi zu dem Hündchen und schlug vor, es „Libero Angstfänger“ zu nennen. Sie selbst wählte eine Thermokombination, einen Tarnumhang und den Namen „Gigi Furchtlos“. „Typisch Schisser!“, verspottete Dubix Hugi, der sich für das „Handbuch der Wintermonsterjagd“ und eine Snowboarderausrüstung entschlossen hatte. Doch Hugi ließ sich nicht beirren, gab sich den Namen Hugi Heldenhaft, aktivierte den Spielstartbutton und streckte Dubix die Zunge raus. Der wollte ihm gerade einen Vogel zeigen, als der Sturm auf dem Monitor ohrenbetäubend zu wüten begann, die Hugidubies eine heftige Böe ergriff und sie davontrug.</p>
<p>Als die Böe abflaute, plumpsten die Hugidubies in tiefes weiches Weiß. Schneeverstaubt blickten sie sich um und dann an. Sie konnten es nicht glauben: Sie waren mitten im Spiel gelandet! Libero Angstfänger bellte aufgebracht. Denn am Horizont bewegte sich etwas, das aussah wie eine gigantische Schneewand, die sich Schritt für Schritt näher schob und auf der „Level 1: Rettet euch vor der Monstermannschaft!“ zu lesen war. Die Hugidubies wollten fliehen, doch mit jedem Schritt versanken sie tief im Schnee. Ein Fortkommen war unmöglich! Jetzt konnten sie erkennen, woraus die Schneewand bestand: Schneemonster! Eine Gruppe marschierender Schneemonster, die sie bald erreichen und überrennen würde! Beherzt schlug Hugi Heldenhaft in seinem Handbuch nach: „Da, ich hab’s! Hier steht genau, wie wir die Schneemonster umkehren lassen können. Libero Angstfänger, du musst ihnen den Marsch blasen und ich sag ihnen, wo es langgeht!“ erklärte er dem Hündchen, das sofort auf seinem Monsterkazoo zu spielen begann. „Kehrt um!“, schrie Hugi Heldenhaft und tatsächlich machten Schneemonster Coach Karotte und sein Pappschnee-Team kehrt. Zur flotten Marschmelodie Libero Angstfängers schritten sie voran und die Hugidubies hintendrein. Sie durchquerten die Schneelandschaft, bis sie an ein Tor gelangten, über dem „Level 2: Besiegt das Schneeungeheuer!“ stand. Kaum durchschritt Coach Karotte das Tor, fiel er um und nach und nach das gesamte Pappschnee-Team.</p>
<p>Vor den Hugidubies türmte sich bald ein riesiger Schneemonsterhaufen auf, aus dem plötzlich Yeti Ursula Ungeheuer erstieg: riesig, zottelig und mit so großem Gebrüll, dass Libero Angstfänger das Monsterkazoo aus dem Maul fiel. Die Hugidubies erstarrten vor Schreck und Ratlosigkeit. Wie sollten sie dieses Ungeheuer besiegen? Mit zitternden Händen blätterte Hugi Heldenhaft in seinem Buch und las stotternd vor: „Mief macht muntre Monster müde.“ Plong — schon landeten Dubix Monsterschrecks Stinkbomben vor Ursula Ungeheuer im Schnee und verbreiteten einen superekligen Geruch. Die Yeti begann zu lächeln, sank zu Boden und schlief selig ein. Die Hugidubies aber liefen dem Gestank davon und durch ein zweites Tor, das mit „Level 3: Entkommt der Teufelswolke!“ beschriftet war. Ping-Pong — da fielen hunderte von Schneebällen auf die Hugidubies nieder. „Autsch!“, klagte Dubix Monsterschreck, den ein Schneeball auf den Popo traf. Droben am Himmel feixte die Teufelswolke Pila und zielte ihre Schneebälle auf die schimpfenden Hugidubies. „Na warte!“, drohte Gigi Furchtlos und warf ihren Tarnumhang über sich und die anderen Hugidubies. Teufelswolke Pila fluchte, weil sie die Hugidubies nun nicht mehr sehen konnte. Diese jedoch stürmten los und lachten so, dass sie die Eisbahn erst bemerkten, als sie sie schon im Monstertempo herunterrutschten, um — schwuuups! — wieder vor dem Monitor zu landen. „Bravo! Ihr habt alle Level geschafft!“, blinkte es dort in Leuchtschrift. Die Hugidubies atmeten schwer, Hugi Heldenhaft zeigte auf das Handbuch, das er noch in der Hand hielt. Er schaltete die Spielkonsole aus und begann weitere spannende Monsterjägertricks vorzulesen. Denn das sollten unbedingt auch die besten GamerInnen wissen: </p>
<p><span>Das Lesen ist schön!</span></p>
      </vuescrollbar>
    </div>
</div>
</template>

<script>
/* eslint no-trailing-spaces: "off" */
import Topmenu from '@/components/Topmenu.vue'
import Toplogo from '@/components/Toplogo.vue'
import Stoppuhr from '@/components/Stoppuhr.vue'
import Player from '@/components/Player.vue'
import Lautsprecher from '@/components/Lautsprecher.vue'
import Copyright from '@/components/Copyright.vue'
// import Scrollbar from 'jquery.scrollbar'
import VueScrollBar from 'vue-perfect-scrollbar'
import Hintergrundbutton from '@/components/Hintergrundbutton.vue'

window.$ = window.jQuery = require('jquery')

export default {
  name: 'game',
  data () {
    return {
      who: 'game'
    }
  },
  components: {
    'top-menu': Topmenu,
    'top-logo': Toplogo,
    'stoppuhr': Stoppuhr,
    'player': Player,
    'lautsprecher': Lautsprecher,
    'copyright': Copyright,
    'vuescrollbar': VueScrollBar,
    'hintergrundbutton': Hintergrundbutton
  },
  mounted () {
    this.$ga.page(this.$router)  
    var muted = (typeof window.muted === 'undefined' ? false : window.muted)
    setTimeout(function () {
      if (typeof window.currentAudioX !== 'undefined') {
        try {
          window.currentAudioX.pause()
          window.currentAudioX.currentTime = 0
          window.currentAudioX = null
        } catch (e) {
          console.log('pause geht nicht')
        }
      }
      if (typeof window.currentAudio !== 'undefined') {
        try {
          window.currentAudio.pause()
          window.currentAudio.currentTime = 0
          window.currentAudio = null
        } catch (e) {
          console.log('pause geht nicht')
        }
      }
      window.currentAudioX = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies2022_Archivseite_Hugi_Titel_Heldenhaft.mp3')
      window.currentAudioX.muted = muted
      window.currentAudioX.play()
      try {
          window.hintergrundSound.pause()
          window.hintergrundSound.currentTime = 0
          window.hintergrundSound = null
      } catch(e){
        console.log('hintergrundsound nicht aktiv')
      }
      window.hintergrundSound = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Hugi_Heldenhaft_Atmo3.mp3')
      window.hintergrundSound.muted = (typeof window.muted !== 'undefined' ? window.muted : false) 
      window.hintergrundSound.loop = true
      try {
        window.hintergrundSound.play()
        window.bgsounddisabled = false
      } catch(e)  {
        window.bgsounddisabled = true
      }  
    }, 1000)
  },
  beforeDestroy () {
    try {
      window.currentAudioX.pause()
    } catch (e) {}
    try {
      window.currentAudio.pause()
    } catch (e) {}
    try {
        window.hintergrundSound.pause()
        window.hintergrundSound.currentTime = 0
        window.hintergrundSound = null
    } catch(e){
    console.log('hintergrundsound nicht aktiv')
    }
  }  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
::-webkit-scrollbar { background: none !important; }
body {margin:0; padding:0;}

/* Z-Index - Level */

.z1{z-index:10;}
.z2{z-index:20;}
.z3{z-index:30;}
.z4{z-index:40;}
.z5{z-index:50;}
.z6{z-index:60;}
.z7{z-index:70;}
.z8{z-index:80;}
.z9{z-index:90;}
.z10{z-index:100;}
.z11{z-index:110;}
.z12{z-index:120;}
.z13{z-index:130;}
.z14{z-index:140;}
.z15{z-index:150;}
.z16{z-index:160;}
.z17{z-index:170;}
.z18{z-index:180;}
.z19{z-index:190;}
.z20{z-index:200;}
.z21{z-index:210;}
.z22{z-index:220;}
.z23{z-index:230;}
.z24{z-index:240;}
.z25{z-index:250;}
.z26{z-index:260;}
.z27{z-index:270;}
.z28{z-index:280;}
.z29{z-index:290;}
.z30{z-index:300;}
.z31{z-index:310;}
.z32{z-index:320;}
.z33{z-index:330;}
.z34{z-index:340;}
.z35{z-index:350;}
.z36{z-index:360;}
.z37{z-index:370;}
.z38{z-index:380;}
.z39{z-index:390;}
.z40{z-index:400;}
.z41{z-index:410;}
.z42{z-index:420;}
.z43{z-index:430;}
.z44{z-index:440;}
.z45{z-index:450;}
.z46{z-index:460;}
.z47{z-index:470;}
.z48{z-index:480;}
.z49{z-index:490;}
.z50{z-index:500;}

/* game */
.game { position: absolute; width: 1920px; height: 1080px; bottom: 0; }

.game .himmel { display: block !important; }

.game .geschichte { position: absolute; top: 170px; left:51%;  }

.game .pfeil_links_big {position: absolute; left: 1vw; top: 40%;}
.game .pfeil_rechts_big {position: absolute; right: 1vw; top: 40%;}


.furchtlos.z30 {
    position: absolute;
    bottom: 210px;
    left: 100px;
animation: dubix_erscheint 0.5s ease-out; animation-delay: 0.2s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}    
.monsterschreck.z30 {
    position: absolute;
    bottom: 270px;
    left: 460px;
animation: dubix_erscheint 0.5s ease-out; animation-delay: 0.4s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
.angstfaenger.z30 {
    position: absolute;
    bottom: 120px;
    left: 750px;
animation: dubix_erscheint 0.5s ease-out; animation-delay: 0.5s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}   
.coach.z30 {
    position: absolute;
    top: 542px;
    left: 642px;
    z-index: 100;
animation: dubix_erscheint 0.5s ease-out; animation-delay: 0.6s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}  

.z20.pappschnee {
    position: absolute;
    top: 640px;
    left: 740px;
animation: dubix_erscheint 0.5s ease-out; animation-delay: 0.7s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}      
.heldenhaft.z30 {
    position: absolute;
    bottom: 150px;
    left: 290px;
animation: dubix_erscheint 0.5s ease-out; animation-delay: 0.7s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}  

@keyframes dubix_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}


.stinkbombe.z30 {
    position: absolute;
    top: -260px;
    left: -439px;
}    
.z30.pappschnee_hud {
    position: absolute;
    top: 628px;
    left: 567px;
    opacity: 0;
    animation: hud_erscheint 7s linear infinite; 
    animation-delay: 2s;
}    

@keyframes hud_erscheint {
  0% {
    opacity: 0;
  }
60% {
    opacity: 0;
  }
  65% {
    opacity: 1;
  }
70% {
    opacity: 1;
  } 
75% {
    opacity: 1;
  }
80% {
    opacity: 0;
  }    
    95% {
    opacity: 1;
  }
    96% {
    opacity: 0;
  }
    97% {
    opacity: 1;
  }
98% {
    opacity: 0;
  }    
    99% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}  

.wolke.z30 {
    position: absolute;
    top: -570px;
    left: -330px;
    opacity:0;
animation: wolke_erscheint 4s ease-out; animation-delay: 2s; animation-fill-mode: forwards;
}
@keyframes wolke_erscheint {
    50% { transform: scale(1); opacity:0; filter: blur(0px); top: -570px; left: -330px;}
    100% { transform: scale(1); opacity:1; filter: blur(0px); top: -260px; left: -500px;}
}

.hud.z30 {
    position: absolute;
    top: -260px;
    left: -481px;
    opacity:0;
    animation: hudbig_erscheint 2s ease-out; animation-delay: 1s; animation-fill-mode: forwards;
}
@keyframes hudbig_erscheint {
    50% { transform: scale(1); opacity:0; filter: blur(5px);}
    100% { transform: scale(1); opacity:1; filter: blur(0px);}
}
    .z20.ursula {
    position: absolute;
    right: 270px;
    bottom: 60px;
    animation: queen_erscheint 10s linear; animation-delay: 1s; animation-fill-mode: forwards;
}  
@keyframes queen_erscheint {
  0% {
    right: 270px;
    bottom: 60px;
  }
10% {
    right: 270px;
    bottom: 50px;
  }
30% {
    right: 50px;
    bottom: 60px;
  }    
40% {
    right: 270px;
    bottom: 50px;
  }
90% {
    right: 270px;
    bottom: 50px;
  }     
  100% {
    right: 0px;
    bottom: 60px;
  }
}  

.fliesstext{
    bottom: 25%;
    left: 10.5%;
    width: 79%;
    font-size: 16pt;
    font-family: 'Open Sans';
    font-weight: 400;
    position: absolute;
    overflow-y: scroll;
    overflow-x: hidden;
    height: 450px;
    padding-right: 15px;
}

/* möve animation */

@-webkit-keyframes hovering /* Safari and Chrome */ {
  from {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  to {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
@keyframes hovering {
  0% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  25% {
    -ms-transform: translate(20px,30px);
    -moz-transform: translate(20px,30px);
    -webkit-transform: translate(20px,30px);
    -o-transform: translate(20px,30px);
    transform: translate(20px,30px);
  }
  50% {
    -ms-transform: translate(-10px,10px);
    -moz-transform: translate(-10px,10px);
    -webkit-transform: translate(-10px,10px);
    -o-transform: translate(-10px,10px);
    transform: translate(-10px,10px);
  }
  75% {
    -ms-transform: translate(-20px,-20px); 
    -moz-transform: translate(-20px,-20px); 
    -webkit-transform: translate(-20px,-20px);
    -o-transform: translate(-20px,-20px);
    transform: translate(-20px,-20px);
  }
  100% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
.game .hovering1 {
  -webkit-animation: hovering 18s linear infinite;
  -moz-animation: hovering 18s linear infinite;
  -ms-animation: hovering 18s linear infinite;
  -o-animation: hovering 18s linear infinite;
  animation: hovering 18s linear infinite;
}
.game .hovering2 {
  -webkit-animation: hovering 22s linear infinite;
  -moz-animation: hovering 22s linear infinite;
  -ms-animation: hovering 22s linear infinite;
  -o-animation: hovering 22s linear infinite;
  animation: hovering 22s linear infinite;
}
.game .hovering3 {
  -webkit-animation: hovering 20s linear infinite;
  -moz-animation: hovering 20s linear infinite;
  -ms-animation: hovering 20s linear infinite;
  -o-animation: hovering 20s linear infinite;
  animation: hovering 20s linear infinite;
}
.game .hovering4 {
  -webkit-animation: hovering 24s linear infinite;
  -moz-animation: hovering 24s linear infinite;
  -ms-animation: hovering 24s linear infinite;
  -o-animation: hovering 24s linear infinite;
  animation: hovering 24s linear infinite;
}
/* schwimmer animation */
@-webkit-keyframes hovering2 /* Safari and Chrome */ {
  from {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  to {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
@keyframes hovering2 {
  0% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  50% {
    -ms-transform: translate(20px,10px);
    -moz-transform: translate(20px,10px);
    -webkit-transform: translate(20px,10px);
    -o-transform: translate(20px,10px);
    transform: translate(20px,10px);
  }
  100% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
.game .hovering2 {
  -webkit-animation: hovering2 10s linear infinite;
  -moz-animation: hovering2 10s linear infinite;
  -ms-animation: hovering2 10s linear infinite;
  -o-animation: hovering2 10s linear infinite;
  animation: hovering2 10s linear infinite;
}

/*************** SCROLLBAR BASE CSS ***************/
 
.scroll-wrapper {
    overflow: hidden !important;
    padding: 0 !important;
    position: relative;
}
 
.scroll-wrapper > .scroll-content {
    border: none !important;
    box-sizing: content-box !important;
    height: auto;
    left: 0;
    margin: 0;
    max-height: none;
    max-width: none !important;
    overflow: scroll !important;
    padding: 0;
    position: relative !important;
    top: 0;
    width: auto !important;
}
 
.scroll-wrapper > .scroll-content::-webkit-scrollbar {
    height: 0;
    width: 0;
}
 
.scroll-element {
    display: none;
}
.scroll-element, .scroll-element div {
    box-sizing: content-box;
}
 
.scroll-element.scroll-x.scroll-scrollx_visible,
.scroll-element.scroll-y.scroll-scrolly_visible {
    display: block;
}
 
.scroll-element .scroll-bar,
.scroll-element .scroll-arrow {
    cursor: default;
}
 
.scroll-textarea {
    border: 1px solid #cccccc;
    border-top-color: #999999;
}
.scroll-textarea > .scroll-content {
    overflow: hidden !important;
}
.scroll-textarea > .scroll-content > textarea {
    border: none !important;
    box-sizing: border-box;
    height: 100% !important;
    margin: 0;
    max-height: none !important;
    max-width: none !important;
    overflow: scroll !important;
    outline: none;
    padding: 2px;
    position: relative !important;
    top: 0;
    width: 100% !important;
}
.scroll-textarea > .scroll-content > textarea::-webkit-scrollbar {
    height: 0;
    width: 0;
}
 
/*************** SIMPLE INNER SCROLLBAR ***************/
 
.scrollbar-inner > .scroll-element,
.scrollbar-inner > .scroll-element div
{
    border: none;
    margin: 0;
    padding: 0;
    position: absolute;
    z-index: 10;
}
 
.scrollbar-inner > .scroll-element div {
    display: block;
    height: 100%;
    left: 0;
    top: 0;
    width: 100%;
}
 
.scrollbar-inner > .scroll-element.scroll-x {
    bottom: 2px;
    height: 8px;
    left: 0;
    width: 100%;
}
 
.scrollbar-inner > .scroll-element.scroll-y {
    height: 100%;
    right: 2px;
    top: 0;
    width: 8px;
}
 
.scrollbar-inner > .scroll-element .scroll-element_outer {
    overflow: hidden;
}
 
.scrollbar-inner > .scroll-element .scroll-element_outer,
.scrollbar-inner > .scroll-element .scroll-element_track,
.scrollbar-inner > .scroll-element .scroll-bar {
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    border-radius: 8px;
}
 
.scrollbar-inner > .scroll-element .scroll-element_track,
.scrollbar-inner > .scroll-element .scroll-bar {
    -ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)";
    filter: alpha(opacity=40);
    opacity: 0.4;
}
 
.scrollbar-inner > .scroll-element .scroll-element_track { background-color: #e0e0e0; }
.scrollbar-inner > .scroll-element .scroll-bar { background-color: #c2c2c2; }
.scrollbar-inner > .scroll-element:hover .scroll-bar { background-color: #919191; }
.scrollbar-inner > .scroll-element.scroll-draggable .scroll-bar { background-color: #919191; }

/* update scrollbar offset if both scrolls are visible */
 
.scrollbar-inner > .scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_track { left: -12px; }
.scrollbar-inner > .scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_track { top: -12px; }

.scrollbar-inner > .scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_size { left: -12px; }
.scrollbar-inner > .scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_size { top: -12px; }

::-webkit-scrollbar {
    width: 15px;
}
 
::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0px #ac8a69; 
    box-shadow: inset 0 0 0px #ac8a69; 
    -webkit-border-radius: 0;
    border-radius: 0;
}
 
::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: #ac8a69; 
}
::-webkit-scrollbar-thumb:window-inactive {
    background: #ac8a69; 
}
::-webkit-scrollbar-button {
    background: none;
}
::-webkit-scrollbar-button:start:decrement,
::-webkit-scrollbar-button:end:increment {
  height: 20px;
  width: 20px;
  display: none;
  background-repeat: no-repeat; 
}
.blubber.blubber_animation {
    top: -25%;
    left: -25%;
    position: absolute;
}
.game .john {
    position: absolute;
    top: 248px;
    left: 787px;
  animation: dubix_erscheint 1s ease-out; animation-delay: 0.5s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;
}
.game .drohne {
    position: absolute;
    top: -320px;
    left: -580px;
}

@keyframes blubber_animation {
    100% { background-position: 0 -9720px; }
}
.game .wassergeist {position: absolute; top: 871px; left: 10px;}
.wassergeist_animation {
  width: 122px;
  height: 204px;
  background: url('/static/assets/game/Wassergeist_Animation.png') top center;
  animation-delay: 1s;
  animation: wassergeist_animation 15s steps(15) infinite;
  transform: scale(1);
  margin-top: 0px;
}

@keyframes wassergeist_animation {
    0% { background-position: 0 -0px; }
    10% { background-position: 0 -3060px; }
    100% { background-position: 0 -3060px; }
}	
span { font-family: FrozenMemory; } 
.player {
    position: absolute;
    top: 660px !important;
    left: 110px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Game.vue